import request from "@/utils/request";

export function share_list(data) {
    return request({
        url: '/share/message_list',
        method: 'post',
        data
    });
}
